/** @see {@link https://github.com/Acre-Rewards/acre-rewards-api/blob/2947415ef01d1866b112203741a1ba8b06dd9a7d/src/common/logger/redacting-logger.ts#L9-L26} */
export function stringifyMessage(message: unknown) {
  // JSON.stringify does NOT convert undefined to a string as it is not valid JSON value.
  // Without this line, stringifyMessage could return a non-string value
  if (message === undefined) {
    return 'undefined - message was undefined'
  }

  if (typeof message === 'string') {
    return message
  }

  return JSON.stringify(message, (_, value) =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    value instanceof Error
      ? { name: value.name, message: value.message, cause: value.cause }
      : value,
  )
}
